/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member */

import { createSelector } from 'reselect';
import { mapWithDefault } from 'utils/dataMapper';

const selectGlobal = (state) => state.get('global');

const makeSelectPolicyId = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('selectedPolicyId'), '')
  );

const makeSelectLoading = () =>
  createSelector(selectGlobal, (globalState) => globalState.get('loading'));

const makeSelectError = () =>
  createSelector(selectGlobal, (globalState) => globalState.get('error'));

const makeSelectRepos = () =>
  createSelector(selectGlobal, (globalState) =>
    globalState.getIn(['userData', 'repositories'])
  );

const makeSelectIsAuthenticated = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('isAuthenticated')
);
const makeSelectFnolReportDateValidation = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('fnolReportDateValidation')
);

const makeSelectValidateStep = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('validateStep')
);

const makeSelectMedicalAuthorityFormLink = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('medicalAuthorityFormLink')
);
const makeSelectMedicalCertificateFormLink = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('medicalCertificateFormLink')
);

const makeSelectAppClaimType = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('appClaimTypes').toJS()
);

const makeSelectValidationDateErrorMessage = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('policyValidationDateErrorMessage')
);

export {
  selectGlobal,
  makeSelectPolicyId,
  makeSelectLoading,
  makeSelectError,
  makeSelectRepos,
  makeSelectIsAuthenticated,
  makeSelectFnolReportDateValidation,
  makeSelectValidateStep,
  // makeSelectfInceptionDate,
  // makeSelectfExpDate,
  makeSelectMedicalAuthorityFormLink,
  makeSelectMedicalCertificateFormLink,
  makeSelectAppClaimType,
  makeSelectValidationDateErrorMessage,
};



// WEBPACK FOOTER //
// ./app/containers/App/selectors.js